<div class="page-detail-wrap vetro-master-bg">
    <h5>{{modalTitle}}</h5>
</div>
<div class="vetro-bg">
    <div class="p-field form-group">
        <div class="row">
            <div class="col-md-1">
                <label for="name" class="col-form-label">Name</label>
            </div>
            <div class="col-md-3 mb-4">
                 <ng-container *ngIf="model.id > 0; else addFrame">
                    <input type="text" pInputText id="name" [(ngModel)]="model.name" readonly />
                </ng-container>
                
                <ng-template #addFrame>
                    <p-dropdown 
                        [options]="frameList" 
                        [(ngModel)]="selectedFrameId" 
                        optionLabel="label" 
                        optionValue="value" 
                        placeholder="Select a frame" 
                        [showClear]="true" 
                        [filter]="true">
                    </p-dropdown>
                </ng-template>
            </div>
            
        </div>
    <div class="row align-items-start">
     <div class="col-md-6 d-flex">
        <div class="me-2" style="padding-top: 4px;">
            <label for="standard" style="font-size: medium;">Frame Materials</label>
        </div>
        <div>
            <p-listbox [options]="frameMaterialList" [(ngModel)]="model.frameMaterial" optionLabel="name" optionValue="id"
                [multiple]="true" [checkbox]="true" [filter]="true"
                [listStyle]="{'max-height':'250px'}"
                [style]="{'width':'15rem'}"></p-listbox>
        </div>
       </div>
    <div class="col-md-6 d-flex">
        <div class="me-2" style="padding-top: 4px;">
            <label for="standard2" style="font-size: medium;">Partners</label>
        </div>
        <div>
            <p-listbox [options]="partnerList" [(ngModel)]="model.partner" optionLabel="name" optionValue="id"
                [multiple]="true" [checkbox]="true" [filter]="true"
                [listStyle]="{'max-height':'250px'}"
                [style]="{'width':'15rem'}"></p-listbox>
          </div>
       </div>
    </div> 
    </div>
    <div class="grid grid-nogutter d-flex justify-content-end">
        <button pButton pRipple label="{{'commonbtn.save'|translate}}" icon="pi pi-check" styleClass="btn-save"
            (click)="save(model)">
        </button>
    </div>
</div>